var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('iframe',{staticStyle:{"height":"100vh"},attrs:{"width":"100%","frameborder":"0","border":"0","cellspacing":"0","src":"https://uvdesk.mirrads.de/en"}})}
var staticRenderFns = []

export { render, staticRenderFns }